<template>
  <v-container fluid class="pa-0 institution-ebay-page">
    <!--TOOLBAR-->
    <div
      class="institution-ebay-toolbar bg-red-darken-3 text-white px-3 py-2 py-md-3 px-md-6 px-lg-8"
    >
      <div class="text-subtitle-1 institution-ebay-toolbar-title">
        {{ $t("institutionEbay.label") }}
      </div>
    </div>

    <!---->
    <div class="col-12 institution-ebay-content">
      <v-row>
        <v-col cols="12">
          <v-card flat>
            <v-row class="flex-wrap ma-0">
              <v-col cols="12" lg="12">
                <v-container class="institution-ebay-form">
                  <!-- PART DESCRIPTION -->
                  <v-toolbar flat theme="dark">
                    <v-toolbar-title>
                      {{
                        $t(
                          "leko_employees.ebay_shipping_price.part_description",
                        )
                      }}
                    </v-toolbar-title>
                  </v-toolbar>
                  <v-row class="mb-2 flex-wrap">
                    <v-col
                      v-if="$store.getters.role === 'SuperAdmin'"
                      cols="12"
                      sm="12"
                      md="12"
                    >
                      <label class="ml-2">{{
                        $t("parts.advanced_search.institution")
                      }}</label>
                      <v-autocomplete
                        v-model="institution"
                        :items="displayedInstitutions"
                        :loading="loadingInstitution"
                        :label="$t('parts.advanced_search.institution')"
                        persistent-hint
                        item-title="title"
                        item-value="_id"
                        variant="solo"
                        color="red-darken-1"
                        class="ml-2 mr-2 pt-2"
                      />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="mt-4">
                      <label class="ml-2">{{
                        $t("parts.inventory.part_title")
                      }}</label>
                      <v-autocomplete
                        v-model="title"
                        v-model:search="searchTitle"
                        v-model:menu="menuOpen"
                        :loading="loadingTitle"
                        :items="titles"
                        :label="$t('parts.inventory.search')"
                        :item-title="() => ''"
                        :custom-filter="customFilter"
                        variant="solo"
                        color="grey-darken-4"
                        append-inner-icon="mdi-magnify"
                        single-line
                        hide-details
                        hide-no-data
                        class="mt-2"
                        clearable
                        autocomplete="off"
                        :disabled="
                          $store.getters.role === 'SuperAdmin' && !institution
                        "
                        @update:search="updateSearch"
                      >
                        <template #item="{ item, props }">
                          <v-list-item
                            v-bind="props"
                            class="listRowColor"
                            @click="selectCode(item)"
                          >
                            <span
                              class="font-weight-bold"
                              v-html="
                                highlight(
                                  item?.raw?.title?.[$store.getters.language] ||
                                    'No Title',
                                  searchTitle,
                                )
                              "
                            />
                          </v-list-item>
                        </template>
                        <template #selection="{ item }">
                          <span v-if="item">
                            {{ item?.raw?.title?.[$store.getters.language] }}
                          </span>
                        </template>
                      </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="3" md="3" class="mt-4">
                      <label class="ml-2">{{
                        $t("institutionEbay.marketplace")
                      }}</label>
                      <v-autocomplete
                        v-model="marketplace"
                        :items="markets"
                        :label="$t('institutionEbay.marketplace')"
                        persistent-hint
                        item-title="title"
                        item-value="value"
                        variant="solo"
                        color="red-darken-1"
                        class="ml-2 mr-2 mt-2"
                        single-line
                        hide-details
                        hide-no-data
                      />
                    </v-col>
                    <v-col
                      v-if="marketplace != 'rr'"
                      cols="12"
                      sm="3"
                      md="2"
                      class="mt-4"
                    >
                      <label class="ml-2">{{
                        $t("institutionEbay.country")
                      }}</label>

                      <v-autocomplete
                        v-model="country"
                        :items="countries"
                        :label="$t('institutionEbay.country')"
                        persistent-hint
                        item-title="title"
                        item-value="code"
                        variant="solo"
                        color="red-darken-1"
                        class="ml-2 mr-2 mt-2"
                      />
                    </v-col>

                    <v-col cols="12" sm="5" md="3" class="mt-4">
                      <label class="">{{
                        $t("institutionEbay.update_shipping_price")
                      }}</label>

                      <v-text-field
                        v-model="price"
                        type="number"
                        oninput="validity.valid || (value = '')"
                        :label="$t('institutionEbay.update_shipping_price')"
                        color="red-darken-1"
                        variant="solo"
                        class="mt-2"
                      />
                    </v-col>

                    <v-col cols="12" sm="5" md="5" class="d-none d-md-block" />

                    <v-col
                      cols="12"
                      sm="6"
                      md="7"
                      class="mt-4 institution-ebay-actions-col"
                    >
                      <div
                        class="institution-ebay-actions d-flex flex-column align-end"
                      >
                      <v-btn
                        v-if="marketplace == 'rr'"
                        :loading="loadingAssignInstitutionPriceRR"
                        :disabled="
                          !(institution && title && marketplace && price)
                        "
                        color="red-darken-1"
                        small
                        class="white--text text-style mb-1 institution-ebay-btn"
                        @click="assignInstitutionPriceRR"
                      >
                        {{
                          $t(
                            "leko_employees.ebay_shipping_price.assign_shipping_reference_institution",
                          )
                        }}
                      </v-btn>
                      <v-btn
                        v-if="marketplace == 'rr'"
                        :loading="loadingAssignInstitutionPriceRRParts"
                        :disabled="
                          !(institution && title && marketplace && price)
                        "
                        color="red-darken-1"
                        small
                        class="white--text text-style mb-1 institution-ebay-btn"
                        @click="assignInstitutionPriceRRParts"
                      >
                        {{
                          $t(
                            "leko_employees.ebay_shipping_price.assign_price_inventory_institution_rr",
                          )
                        }}
                      </v-btn>
                      <v-btn
                        v-if="marketplace != 'rr'"
                        :loading="loadingAssignInstitutionPrice"
                        :disabled="
                          !(
                            institution &&
                            title &&
                            marketplace &&
                            country &&
                            price
                          )
                        "
                        color="red-darken-1"
                        small
                        class="white--text text-style mb-1 institution-ebay-btn"
                        @click="assignInstitutionPrice"
                      >
                        {{
                          $t(
                            "leko_employees.ebay_shipping_price.assign_shipping_reference_institution",
                          )
                        }}
                      </v-btn>
                      <v-btn
                        v-if="marketplace != 'rr'"
                        :loading="loadingInventoryPrice"
                        :disabled="
                          !(
                            institution &&
                            title &&
                            marketplace &&
                            country &&
                            price
                          )
                        "
                        color="red-darken-1"
                        small
                        class="white--text text-style institution-ebay-btn"
                        @click="assignPriceInventory"
                      >
                        {{
                          $t(
                            "leko_employees.ebay_shipping_price.assign_price_inventory_institution",
                          )
                        }}
                      </v-btn>
                      <br />
                      <small
                        v-if="marketplace != 'rr'"
                        class="card text-grey"
                        >{{
                          $t("leko_employees.ebay_shipping_price.button_note")
                        }}</small
                      >
                      </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                      <v-container v-if="titleDetails" class="institution-ebay-details-wrap">
                        <v-card class="pa-3 text-start institution-ebay-details">
                          <div class="mb-2 redColor text-white pa-1">
                            <h3>
                              {{
                                $t(
                                  "leko_employees.ebay_shipping_price.title_details",
                                )
                              }}
                            </h3>
                          </div>
                          <div
                            v-if="$store.getters.role === 'SuperAdmin'"
                            class="text-start mb-1 col-12 pl-2"
                          >
                            <strong class="pt-1">partCode: </strong>
                            <a>{{ titleDetails.partCode }}</a>
                          </div>
                          <div class="text-start mb-1 col-12 pl-2">
                            <strong class="pt-1"
                              >{{ $t("institutionEbay.weight_range") }}
                            </strong>
                            <a>{{ titleDetails.weightRange }} kg</a>
                          </div>
                          <div class="text-start mb-1 pl-2">
                            <strong>{{ $t("institutionEbay.label") }}: </strong>

                            <div
                              v-for="(
                                platformCosts, platform
                              ) in titleDetails.shippingCosts"
                              :key="platform"
                            >
                              <h3>
                                {{
                                  platform.charAt(0).toUpperCase() +
                                  platform.slice(1)
                                }}
                              </h3>

                              <ul v-if="isCountryCostMap(platformCosts)">
                                <li
                                  v-for="(cost, country) in platformCosts"
                                  :key="country"
                                >
                                  {{ String(country).toUpperCase() }}: €{{ cost }}
                                </li>
                              </ul>
                              <ul v-else>
                                <li>€{{ platformCosts }}</li>
                              </ul>
                            </div>
                          </div>
                        </v-card>
                      </v-container>
                    </v-col>
                    <!-- <v-col
                      xs="12"
                      sm="6"
                      class="ml-auto"
                      d-flex
                    >
                      <v-btn
                        :loading="loadingAssignPartPrice"
                        :disabled="!(institution && title && marketplace && country && price)"
                        color="red-darken-1"
                        class="white--text"
                        @click="assignPartPrice"
                      >
                        <img
                          height="24"
                          width="24"
                          class="mr-2"
                          src="@/assets/icons/insert_parts.svg"
                        >  {{ $t('leko_employees.ebay_shipping_price.assign_shipping_cost_part') }}
                      </v-btn>
                    </v-col> -->
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
            <v-row class="pa-1 flex-wrap ma-0">
              <v-col cols="12" sm="12" md="8" class="pl-3 pb-0 mb-0">
                <v-card flat>
                  <v-alert
                    :value="true"
                    type="info"
                    border="bottom"
                    variant="outlined"
                    text
                  >
                    <div class="col-12 pa-0">
                      <div class="pt-2 col-12">
                        <strong>📌 {{ $t("institutionEbay.formula") }}:</strong>
                        ({{ $t("institutionEbay.part_price") }} +
                        {{ $t("institutionEbay.shipping") }}) * 12,5%
                      </div>
                      <div class="pt-2 col-12">
                        <strong>💡 {{ $t("institutionEbay.example") }}:</strong>
                        <strong> {{ $t("institutionEbay.price_ebay") }} </strong
                        >= (Fanale: 90 € + 10 €
                        {{ $t("institutionEbay.shipping") }}) * 1.125 =
                        <strong>125 €</strong>
                      </div>
                    </div>
                    <div
                      class="col-12 pt-1 ml-3"
                      style="color: grey !important"
                    >
                      *{{ $t("institutionEbay.ebay_comission_1") }}:
                      <strong>
                        {{ $t("institutionEbay.ebay_comission_2") }}</strong
                      >
                    </div>
                  </v-alert>
                </v-card>
              </v-col>

              <v-col cols="12" sm="12" md="4">
                <v-card flat>
                  <v-alert
                    :value="true"
                    type="error"
                    border="bottom"
                    variant="outlined"
                    text
                  >
                    {{ $t("institutionEbay.parts_info") }}
                  </v-alert>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-if="title && marketplace != 'rr'" class="col-12 institution-ebay-weight-section">
      <div class="pa-4 pa-md-4">
        <v-toolbar flat theme="dark" class="">
          <v-toolbar-title>
            {{ $t("institutionEbay.weight_range") }}
          </v-toolbar-title>
        </v-toolbar>
      </div>

      <v-row class="institution-ebay-weight-row flex-wrap ma-0 px-3">
        <v-col cols="12" sm="4" md="4" lg="4">
          <label>{{ $t("leko_employees.shippings.weight") }}</label>
          <v-autocomplete
            v-model="selectedWeightRange"
            :items="weightRanges"
            :label="$t('leko_employees.shippings.weight')"
            persistent-hint
            item-title="label"
            item-value="value"
            variant="solo"
            color="red-darken-1"
            class="mt-2"
          />
        </v-col>
        <v-col cols="12" sm="3" md="2" lg="2" class="d-flex align-end">
          <v-btn
            :loading="loadingUpdateWeight"
            :disabled="!selectedWeightRange"
            color="red-darken-1"
            class="white--text institution-ebay-btn"
            @click="updateWeightRange"
          >
            <v-icon class="mr-2"> mdi-weight-kilogram </v-icon>
            {{ $t("leko_employees.ebay_shipping_price.update_weight") }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="5" md="6" lg="6">
          <v-alert
            :value="true"
            type="error"
            border="bottom"
            class="mt-3 mt-sm-0"
            variant="outlined"
            text
          >
            {{ $t("institutionEbay.weight_info") }}
          </v-alert>
        </v-col>
      </v-row>
    </div>
    <div class="vue-mastery ma-3 institution-ebay-video-link">
      <a
        href="https://youtu.be/UtNAToxBdXY"
        target="_blank"
        rel="sponsored noopener"
        title=""
        >{{ $t("institutionEbay.watch_video") }}</a
      >
    </div>
    <v-dialog v-model="loading" persistent content-class="institution-ebay-loading">
      <v-card
        variant="outlined"
        color="transparent"
        class="d-flex align-center justify-center institution-ebay-loading-card"
        transparent
      >
        <v-progress-circular color="#D32F2F" indeterminate size="100" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="success" max-width="300">
      <v-alert v-model="success" type="success" dismissible :value="true">
        {{ $t("institutions.form.success") }}
      </v-alert>
    </v-dialog>
    <v-dialog v-model="error" max-width="300">
      <v-alert v-model="error" type="error" dismissible :value="true">
        {{ $t("Error") }}
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import getRequest from "../api/getRequest";
import putRequest from "../api/putRequest";

export default {
  data: () => ({
    searchTitle: null,
    loadingTitle: false,
    title: null,
    titles: [],
    price: 0,
    loadingAssignPrice: false,
    institution: null,
    institutions: [],
    marketplace: "ebay",
    markets: [
      { title: "eBay", value: "ebay" },
      { title: "Google", value: "google" },
    ],
    country: "it",
    countries: [
      { title: "Italy", code: "it" },
      { title: "Germany", code: "de" },
      { title: "France", code: "fr" },
      { title: "Spain", code: "es" },
      //   { title: 'United Kingdom', code: 'uk' },
    ],
    loadingInstitution: false,
    loadingAssignInstitutionPrice: false,
    loadingAssignInstitutionPriceRR: false,
    loadingAssignInstitutionPriceRRParts: false,
    loadingAssignPartPrice: false,
    loading: false,
    code: null,
    category: null,
    success: false,
    error: false,
    displayedInstitutions: [],
    titleDetails: null,
    selectedWeightRange: "",
    weightRanges: [
      { value: null, label: "Default" },
      { value: "0-2", label: "0-2 kg" },
      { value: "2,1-5", label: "2,1-5 kg" },
      { value: "5,1-10", label: "5,1-10 kg" },
      { value: "10,1-15", label: "10,1-15 kg" },
      { value: "15,1-25", label: "15,1-25 kg" },
      { value: "25,1-50", label: "25,1-50 kg" },
      { value: "50,1-75", label: "50,1-75 kg" },
      { value: "75,1-100", label: "75,1-100 kg" },
      { value: "100,1", label: "100+ kg" },
      { value: "101,1-150", label: "101,1-150 kg" },
      { value: "150,1-200", label: "150,1-200 kg" },
      { value: "201,1-250", label: "201,1-250 kg" },
      { value: "250,1-300", label: "250,1-300 kg" },
    ],
    loadingUpdateWeight: false,
    loadingInventoryPrice: false,
    menuOpen: false,
    selectingItem: false,
    rrMember: false,
  }),
  watch: {
    async searchTitle(newValue) {
      if (this.selectingItem) {
        this.selectingItem = false;
        return;
      }
      if (newValue) {
        if (this.selectingItem) {
          this.selectingItem = false;
          return;
        }
        this.loadingTitle = true;
        try {
          const response = await getRequest(
            "/info-car/parts",
            `title=${encodeURIComponent(newValue)}&language=${this.$store.getters.language}`,
          );
          this.titles = response.parts || [];
        } catch (error) {
          this.titles = [];
        } finally {
          this.loadingTitle = false;
          this.menuOpen = this.titles.length > 0;
        }
      } else {
        if (!this.title) {
          this.titles = [];
          this.menuOpen = false;
        } else {
          const selected = this.titles.find((t) => t.partCode === this.title);
          if (selected) {
            this.selectingItem = true; // prevent re-trigger
            this.searchTitle =
              selected.title?.[this.$store.getters.language] || "";
            this.menuOpen = false;
          }
        }
      }
    },
    title: {
      handler(newTitle) {
        if (newTitle) {
          this.getTitleDetails(newTitle.partCode || newTitle);
        }
      },
      deep: true,
    },
    marketplace() {
      if (!this.title?.partCode) return;
      this.getTitleDetails(this.title.partCode);
    },
  },
  created() {
    this.getInstitutions();
    if (
      this.$store.getters.role == "InstitutionAdmin" &&
      this.$store.getters.rr_member == true
    ) {
      this.rrMember = true;
      this.markets.push({ title: "ReteRicambi", value: "rr" });
    }
  },
  methods: {
    isCountryCostMap(value) {
      return value !== null && typeof value === "object" && !Array.isArray(value);
    },
    selectCode(item) {
      this.title = item.raw;
      this.selectingItem = true;
    },
    highlight(title, search) {
      let result = title || "";
      if (search) {
        const index = title
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase());
        // mark the text.
        if (index > -1)
          result = [
            title.slice(0, index),
            "<mark>",
            title.slice(index, index + search.length),
            "</mark>",
            title.slice(index + search.length),
          ].join("");
      }
      return `<span>${result}</span>`;
    },
    getInstitutions() {
      this.loadingInstitution = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          if (this.$store.getters.role === "SuperAdmin") {
            this.displayedInstitutions = this.institutions;
          } else {
            this.displayedInstitutions = this.institutions.filter(
              (institution) =>
                institution._id === this.$store.getters.institutionId,
            );
            this.institution = this.displayedInstitutions[0];
          }
          this.loadingInstitution = false;
        })
        .catch(() => {
          this.loadingInstitution = false;
        });
    },
    getTitleDetails(partCode) {
      this.titleDetails = null;
      getRequest(
        "/shipping-reference-cost/",
        `partCode=${partCode}&institutionId=${this.institution._id || this.institution}`,
      )
        .then((response) => {
          if (response && response.data) {
            this.titleDetails = response.data;
            const marketplace = this.marketplace; // 'ebay', 'google', 'rr'

            switch (marketplace) {
              case "ebay":
                this.price = response.data.shippingCosts?.ebay?.it ?? null;
                break;
              case "google":
                this.price = response.data.shippingCosts?.google?.price ?? null;
                break;
              case "rr":
                this.price = response.data.shippingCosts?.rr ?? null;
                break;
              default:
                this.price = null;
            }

            this.selectedWeightRange = response.data.weightRange;
          } else {
            this.price = null;
          }
        })
        .catch(() => {});
    },
    assignInstitutionPrice() {
      this.loadingAssignInstitutionPrice = true;
      this.loading = true;
      putRequest("/shipping-reference-cost", "", {
        partCode: this.title.partCode,
        cost: this.price,
        institutionId: this.institution._id,
        marketplace: this.marketplace,
        country: this.country,
        weightRange: this.selectedWeightRange,
      })
        .then((response) => {
          if (response) {
            this.success = true;
            this.getTitleDetails(response.data.partCode);
            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingAssignInstitutionPrice = false;
          this.loading = false;
        });
    },
    assignPriceInventory() {
      this.loadingInventoryPrice = true;
      this.loading = true;
      putRequest("/shipping-reference-cost/not-on-ebay", "", {
        partCode: this.title.partCode,
        cost: this.price,
        institutionId: this.institution._id,
        marketplace: this.marketplace,
        country: this.country,
        weightRange: this.selectedWeightRange,
      })
        .then((response) => {
          if (response) {
            this.success = true;
            this.getTitleDetails(this.title.partCode);
            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingInventoryPrice = false;
          this.loading = false;
        });
    },
    assignPartPrice() {
      this.loadingAssignPartPrice = true;
      this.loading = true;
      putRequest("/shipping-reference-cost/parts", "", {
        partCode: this.title.partCode,
        cost: this.price,
        institutionId: this.institution._id,
        marketplace: this.marketplace,
        country: this.country,
        weightRange: this.selectedWeightRange,
      })
        .then((response) => {
          if (response) {
            this.success = true;
            this.getTitleDetails(this.title.partCode);
            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingAssignPartPrice = false;
          this.loading = false;
        });
    },
    assignInstitutionPriceRR() {
      this.loadingAssignInstitutionPriceRR = true;
      this.loading = true;
      putRequest("/shipping-reference-cost", "", {
        partCode: this.title.partCode,
        cost: this.price,
        institutionId: this.institution._id || this.institution,
        marketplace: this.marketplace,
        weightRange: this.selectedWeightRange,
      })
        .then((response) => {
          if (response) {
            this.success = true;
            this.getTitleDetails(this.title.partCode);
            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingAssignInstitutionPriceRR = false;
          this.loading = false;
        });
    },
    assignInstitutionPriceRRParts() {
      this.loadingAssignInstitutionPriceRRParts = true;
      this.loading = true;
      putRequest("/shipping-reference-cost/parts", "", {
        partCode: this.title.partCode,
        cost: this.price,
        institutionId: this.institution._id || this.institution,
        marketplace: this.marketplace,
        weightRange: this.selectedWeightRange,
      })
        .then((response) => {
          if (response) {
            this.success = true;
            this.getTitleDetails(this.title.partCode);
            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingAssignInstitutionPriceRRParts = false;
          this.loading = false;
        });
    },

    customFilter(item, queryText, itemText) {
      if (!queryText) return true;
      const searchText = queryText.toLowerCase();
      const language = this.$store.getters.language;

      // Check main title
      const mainTitle = itemText.raw?.title?.[language]?.toLowerCase() || "";
      if (mainTitle.includes(searchText)) return true;

      // Check related titles
      // const relatedTitles = itemText.raw?.related || [];
      // return relatedTitles.some((related) => {
      //   const relatedTitle = related?.title?.[language]?.toLowerCase() || "";
      //   return relatedTitle.includes(searchText);
      // });
    },
    updateWeightRange() {
      this.loadingUpdateWeight = true;
      this.loading = true;
      putRequest("/shipping-reference-cost/weight-range", "", {
        partCode: this.title.partCode,
        institutionId: this.institution._id,
        weightRange: this.selectedWeightRange,
      })
        .then((response) => {
          if (response) {
            this.success = true;
            this.getTitleDetails(this.title.partCode);
            setTimeout(() => {
              this.success = false;
            }, 3000);
          }
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.error = false;
          }, 3000);
        })
        .finally(() => {
          this.loadingUpdateWeight = false;
          this.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.text-grey {
  color: grey;
  margin-right: 5px;
}
.text-start {
  text-align: start !important;
}
.vue-mastery {
  background-color: #e7ecf3;
  padding: 1em 1.25em;
  border-radius: 2px;
  color: #486491;
  position: relative;
  margin-top: 1em;
}
.vue-mastery a {
  color: #486491 !important;
  position: relative;
  padding-left: 36px;
}
.vue-mastery a:before {
  content: "";
  position: absolute;
  display: block;
  width: 30px;
  height: 30px;
  top: -5px;
  left: -4px;
  border-radius: 50%;
  background-color: #73abfe;
}
.vue-mastery a:after {
  content: "";
  position: absolute;
  display: block;
  width: 0;
  height: 0;
  top: 5px;
  left: 8px;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 8px solid #fff;
}
.text-style {
  font-size: 16px;
}
.display {
  display: flex;
}

.institution-ebay-toolbar-title {
  line-height: 1.35;
  word-break: break-word;
}

.institution-ebay-details a {
  word-break: break-word;
}

.institution-ebay-loading-card {
  min-height: 200px;
  background: transparent;
  box-shadow: none;
}

@media (min-width: 960px) {
  .institution-ebay-actions-col {
    margin-left: auto;
  }

  .institution-ebay-actions {
    align-items: flex-end;
  }
}

@media (max-width: 959.98px) {
  .institution-ebay-toolbar-title {
    font-size: 1rem;
    text-align: center;
  }

  .institution-ebay-content {
    padding: 0 8px 16px;
  }

  .institution-ebay-form,
  .institution-ebay-details-wrap {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }

  .institution-ebay-actions-col {
    margin-left: 0 !important;
  }

  .institution-ebay-actions {
    align-items: stretch !important;
    width: 100%;
  }

  .institution-ebay-btn {
    width: 100%;
    max-width: 100%;
    white-space: normal;
    height: auto;
    min-height: 36px;
    text-align: left;
    justify-content: flex-start;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .institution-ebay-btn :deep(.v-btn__content) {
    white-space: normal;
    line-height: 1.2;
    text-align: left;
  }

  .institution-ebay-weight-section {
    padding: 0 4px;
  }

  .institution-ebay-video-link {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }

  .institution-ebay-loading-card {
    min-height: 120px;
  }

  .text-style {
    font-size: 14px;
  }
}

@media (max-width: 625px) {
  .text-style {
    font-size: 12px;
  }
  .display {
    display: block;
  }
}
</style>
